<div class="modal inmodal fade in parcel-modal create-modal show">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title col-sm-8">No Buildings</h4>
            </div>
            <div class="modal-body">
                No buildings assigned to your user, please contact your property manager.
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/no-buildings-modal/no-buildings-modal.component.html